<template>
  <v-toolbar flat class="transparent toolbar">
    <!-- Loading state - mostrar skeleton enquanto carrega -->
    <div v-if="isSystemLoading" style="width: 150px; height: 150px; display: flex; align-items: center; justify-content: center;">
      <v-progress-circular
        indeterminate
        color="primary"
        size="32"
      ></v-progress-circular>
    </div>
    
    <!-- Content loaded - mostrar logo ou nome -->
    <template v-else>
      <h2
        v-if="this.logoLink === '' || this.logoLink === null"
        style="font-size: 18px; text-align: left; color: #000"
      >
        {{ account.fantasy_name }}
      </h2>
      <div v-else class="logo-container" :class="logoAspectClass">
        <v-img
          v-bind:src="logoLink"
          contain
          max-height="120"
          max-width="200"
          @error="onImageError"
          :key="logoUpdateTimestamp"
        > </v-img>
      </div>
    </template>
  </v-toolbar>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SidemenuHeader",
  created() {
    // Listener para atualização de logo
    this.$root.$on('logo-updated', this.onLogoUpdated);
  },
  beforeDestroy() {
    this.$root.$off('logo-updated', this.onLogoUpdated);
  },
  data() {
    return {
      logoUpdateTimestamp: Date.now(), // Para forçar atualização da logo
      logoAspectClass: '',
    };
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      partner: "account/partner",
      partnerName: "account/partnerName",
      color: "account/color",
      logoLinkFromStore: "account/logoLink",
      systemLogoUrl: "system/logoUrl",
      systemConfiguration: "system/systemConfiguration",
      isSystemLoading: "system/isLoading",
    }),
    logoLink() {
      // Usar timestamp para garantir reatividade
      this.logoUpdateTimestamp;
      
      // Só retornar logo se não estiver carregando configuração do sistema
      if (this.isSystemLoading) {
        return '';
      }
      
      // Priorizar logo da configuração do sistema (reativo às mudanças)
      if (this.systemConfiguration && this.systemConfiguration.logo_url && 
          this.systemConfiguration.logo_url.trim() !== '' && 
          !this.systemConfiguration.logo_url.includes('/logo_flowit.png')) {
        let logoUrl = this.systemConfiguration.logo_url;
        
        // Para URLs externas (S3, Stackhero, etc.), adicionar timestamp para cache busting
        if (logoUrl.includes('http') && (logoUrl.includes('s3.amazonaws.com') || logoUrl.includes('stackhero'))) {
          const separator = logoUrl.includes('?') ? '&' : '?';
          logoUrl = `${logoUrl}${separator}cb=${this.logoUpdateTimestamp}`;
        }
        
        // Para URLs de API proxy, adicionar timestamp também
        if (logoUrl.includes('/api/')) {
          const separator = logoUrl.includes('?') ? '&' : '?';
          logoUrl = `${logoUrl}${separator}cb=${this.logoUpdateTimestamp}`;
        }
        
        return logoUrl;
      }
      
      // Fallback para logo da conta se disponível
      if (this.logoLinkFromStore && this.logoLinkFromStore.trim() !== '') {
        let logoUrl = this.logoLinkFromStore;
        
        // Adicionar cache busting para URLs externas
        if (logoUrl.includes('http') && (logoUrl.includes('s3.amazonaws.com') || logoUrl.includes('stackhero'))) {
          const separator = logoUrl.includes('?') ? '&' : '?';
          logoUrl = `${logoUrl}${separator}cb=${this.logoUpdateTimestamp}`;
        }
        
        return logoUrl;
      }
      
      // Último fallback para logo padrão apenas se configuração já foi carregada
      return '/img/logo_flowit.png';
    },
  },
  watch: {
    account(newValues) {
      this.newAccount = newValues;
    },
    logoLink: {
      immediate: true,
      handler(url) {
        this.detectLogoAspect(url);
      },
    },
  },
  methods: {
    goTo(route) {
      this.$router.push({ name: route });
    },
    onImageError() {
      // Se o erro foi em uma URL externa, tentar forçar o timestamp para cache busting
      const currentUrl = this.logoLink;
      if (currentUrl && currentUrl.includes('http') && !currentUrl.includes('cb=')) {
        this.logoUpdateTimestamp = Date.now();
        return; // Permite que o computed logoLink se atualize com timestamp
      }
      
      // Se já tem timestamp ou é uma URL local, usar logo padrão
      this.$store.commit('account/LOGO_LINK', '/img/logo_flowit.png');
    },
    onLogoUpdated() {
      // Atualizar timestamp para forçar re-computation do logoLink
      this.logoUpdateTimestamp = Date.now();
    },
    detectLogoAspect(url) {
      if (!url) {
        this.logoAspectClass = '';
        return;
      }
      const img = new Image();
      img.onload = () => {
        const ratio = img.naturalWidth / img.naturalHeight;
        if (ratio > 2.5) this.logoAspectClass = 'logo-wide';
        else if (ratio < 0.75) this.logoAspectClass = 'logo-tall';
        else this.logoAspectClass = 'logo-square';
      };
      img.src = url;
    },
  },
};
</script>
<style>
.toolbar {
  max-width: 300px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 120px;
  padding: 10px;
}

.logo-container.logo-square {
  padding: 4px;
}

.logo-container.logo-tall {
  width: 120px;
  padding: 4px;
}

.logo-container .v-image {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
